import { useEditableCollectionsQuery } from "@/shared/services/graphql/generated/consumer-graph-types";
import { computed, watchEffect } from "vue";

export const useEditableCollections = () => {
    const { result, error, loading, refetch } = useEditableCollectionsQuery();

    const collections = computed(() => {
        if (result.value?.editableCollections.collections) {
            return result.value?.editableCollections.collections.map((collection) => {
                return {
                    id: collection?.node?.id ?? "",
                    title: collection?.node?.displayName ?? "",
                };
            });
        }
        return [];
    });

    watchEffect(() => {
        if (error.value) console.error(error.value);
    });

    return { loading, error, collections, refetch };
};
